// extracted by mini-css-extract-plugin
module.exports = {"heroRoot":"HeroSlider_heroRoot__qjW2b","slideRoot":"HeroSlider_slideRoot__urVTD","slideContent":"HeroSlider_slideContent__jqGt_"};